var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgActiveTaskEmpty(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 140,
    height: 140,
    viewBox: "0 0 140 140",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Empty state Icon"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 3",
    cx: 70,
    cy: 70,
    r: 70,
    fill: "#F4F4F4"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group 634000"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 3170",
    x: 81,
    y: 48,
    width: 35.9512,
    height: 49.288,
    rx: 6,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 3167",
    x: 86.2188,
    y: 77.4299,
    width: 26.0936,
    height: 3,
    fill: "#EFEFEF"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 3173",
    x: 86.2188,
    y: 84.4299,
    width: 26.0936,
    height: 3,
    fill: "#EFEFEF"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 3172",
    x: 86,
    y: 67,
    width: 26,
    height: 8,
    fill: "#EFEFEF"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 3171",
    x: 86,
    y: 51,
    width: 12,
    height: 12,
    rx: 6,
    fill: "#F8F8F8"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group 634001"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 3170_2",
    x: 16,
    y: 48,
    width: 35.9512,
    height: 49.288,
    rx: 6,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 3167_2",
    x: 34,
    y: 57,
    width: 14,
    height: 3,
    fill: "#EFEFEF"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 3172_2",
    x: 20,
    y: 67,
    width: 28,
    height: 3,
    fill: "#EFEFEF"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 3173_2",
    x: 20,
    y: 73,
    width: 28,
    height: 3,
    fill: "#EFEFEF"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 3174",
    x: 20,
    y: 79,
    width: 28,
    height: 8,
    fill: "#EFEFEF"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 3171_2",
    x: 20.2188,
    y: 52,
    width: 12,
    height: 12,
    rx: 6,
    fill: "#F8F8F8"
  })), /*#__PURE__*/React.createElement("g", {
    id: "clipboard-text"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Vector"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M80.1667 38C90.7117 38.6908 96 43.411 96 60.9488V83.9744C96 99.3248 92.8333 107 77 107H58C42.1667 107 39 99.3248 39 83.9744V60.9488C39 43.4494 44.2883 38.6908 54.8333 38",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.1667 38C90.7117 38.6908 96 43.411 96 60.9488V83.9744C96 99.3248 92.8333 107 77 107H58C42.1667 107 39 99.3248 39 83.9744V60.9488C39 43.4494 44.2883 38.6908 54.8333 38",
    stroke: "#EFEFEF",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M59.75 45.25H75.25C83 45.25 83 41.375 83 37.5C83 29.75 79.125 29.75 75.25 29.75H59.75C55.875 29.75 52 29.75 52 37.5C52 45.25 55.875 45.25 59.75 45.25Z",
    fill: "white",
    stroke: "#EFEFEF",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M55 69.2747H82.125",
    stroke: "#EFEFEF",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M55 60.2747H82.125",
    stroke: "#EFEFEF",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M55 80.7747H71.9725",
    stroke: "#EFEFEF",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group 634147"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M96.9686 54.2581L82.9733 68.2554C82.4405 68.7882 81.9077 69.8363 81.8011 70.6001L81.0374 75.9467C80.7532 77.8829 82.1208 79.2329 84.0567 78.9665L89.4026 78.2027C90.1485 78.0961 91.1964 77.5632 91.747 77.0303L105.742 63.033C108.158 60.6173 109.294 57.8107 105.742 54.2581C102.19 50.7055 99.384 51.8423 96.9686 54.2581Z",
    fill: "white",
    stroke: "#EFEFEF",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M95 56C96.2206 60.3543 99.6275 63.7611 104 65",
    stroke: "#EFEFEF",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgActiveTaskEmpty);
export default __webpack_public_path__ + "static/media/activeTaskEmpty.1a541be7a5b8948f1aac15928b43043b.svg";
export { ForwardRef as ReactComponent };